import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-waves-effect-page-configurator',
	templateUrl:'./WavesEffectPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./WavesEffectPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WavesEffectPageConfiguratorPluginCompPage
{
	mdContent_1157 = `\`\`\`java
import com.jwebmp.plugins.waveseffect.WavesEffectPageConfigurator;
\`\`\``;
	mdContent_1158 = `\`\`\`java
module com.myapp {
    requires com.jwebmp.plugins.waveseffect;
}
\`\`\``;
}
